/**
 * The capture contract: what saving a Service Plan as a template asks of the user and reports back.
 *
 * Capture converts every dated schedule a template cannot hold on its own (fixed weekdays become "N days
 * a week", an end date becomes an occurrence count, a first-due date is dropped). Only a list of specific
 * dates has no automatic equivalent, so that one answer is the user's.
 */
import { ServicePlanTemplate } from './service.plan.template';

/** What a task's list of specific dates becomes on the template. */
export enum ServicePlanCaptureDatesList {
    /** The task keeps no schedule of its own, so it runs on every working day. */
    None = 'none',
    /** The task joins every visit other tasks create. */
    PerVisit = 'perVisit',
}

/** The new template plus how many task schedules capture rewrote, so the UI can say so. */
export interface ServicePlanTemplateCaptureResult extends ServicePlanTemplate {
    convertedSchedules: number;
}
